
const namespaced = true
const state = {
  data: null,
  loading: false,
  error: false
}
const getters = {
}
const mutations = {
  SETDATA (state, payload) {
    state.data = payload
  }
}

const actions = {
  async setData ({ commit, dispatch, state }, payload) {
    for (const el of payload) {
      for (const diff of el.diff) {
        if (diff[0] === 'image_ids' || diff[0] === 'delete_image_ids') {
          const added = []
          diff[2].forEach(img => !diff[1]?.includes(img) ? added.push(img) : null)
          const imgAdd = {}
          for (const img of added) {
            const addedImg = await dispatch('parts/getImageBuId', img, { root: true })
            if (addedImg) {
              if (!imgAdd[addedImg.type]) imgAdd[addedImg.type] = []
              imgAdd[addedImg.type].push(addedImg)
            }
          }
          diff.push(imgAdd)
        } else if (diff[0] === 'attrs') {
          const added = []
          const deleted = []
          for (const key in diff[1]) {
            diff[1][key].forEach(attr => !diff[2]?.[key]?.includes(attr) ? deleted.push(attr) : null)
          }
          for (const key in diff[2]) {
            diff[2][key].forEach(attr => !diff[1]?.[key]?.includes(attr) ? added.push(attr) : null)
          }
          const attrAdd = []
          if (added.length) {
            const addedAttr = await dispatch('attributes/getAttrsById', added.join(), { root: true })
            if (addedAttr) {
              addedAttr.forEach(attr => {
                attrAdd.push({ ...attr, isNew: true })
              })
            }
          }
          if (deleted.length) {
            const deletedAttr = await dispatch('attributes/getAttrsById', deleted.join(), { root: true })
            if (deletedAttr) {
              deletedAttr.forEach(attr => {
                attrAdd.push({ ...attr, isOld: true })
              })
            }
          }
          diff.push(attrAdd)
        } else if (diff[0] === 'attributes') {
          const added = []
          const deleted = []
          diff[1].forEach(attr => !diff[2].includes(attr) ? deleted.push(attr) : null)
          diff[2].forEach(attr => !diff[1].includes(attr) ? added.push(attr) : null)
          const attrAdd = {}
          if (added.length) {
            const addedAttr = await dispatch('attributes/getAttrsById', added.join(), { root: true })
            if (addedAttr) {
              addedAttr.forEach(attr => {
                if (!attrAdd[attr.type]) attrAdd[attr.type] = []
                attrAdd[attr.type].push({
                  ...attr,
                  isNew: true
                })
              })
            }
          }
          if (deleted.length) {
            const deletedAttr = await dispatch('attributes/getAttrsById', deleted.join(), { root: true })
            if (deletedAttr) {
              deletedAttr.forEach(attr => {
                if (!attrAdd[attr.type]) attrAdd[attr.type] = []
                attrAdd[attr.type].push({
                  ...attr,
                  isOld: true
                })
              })
            }
          }
          diff.push(attrAdd)
        } else if (diff[0] === 'allowed_params') {
          for (const key in diff[1]) {
            const selected = diff[1][key].selected.map(select => Number(select))
            diff[1][key].selected = selected
          }
          for (const key in diff[2]) {
            const selected = diff[2][key].map(select => Number(select))
            diff[2][key] = selected
          }
        } else if (diff[0] === 'cond') {
          const condition = []
          diff[1].forEach((condOld, index) => {
            condition.push([])
            for (const key in condOld) {
              const isOld = diff[2]?.[index]?.[key]?.join() !== condOld[key]?.join()
              condition[index].push({
                name: `${Number(key) ? `par ${key}` : `${key}`} = ${condOld[key].join()}`,
                showValue: isOld ? 'isOld' : '',
                key: key,
                value: condOld[key].join()
              })
            }
          })
          diff[2].forEach((condNew, index) => {
            if (!condition[index]) condition.push([])
            for (const key in condNew) {
              const cond = condition[index].find(elC => elC.key === key)
              const isNew = cond?.value !== condNew[key]?.join()
              if (isNew) {
                condition[index].push({
                  name: `${Number(key) ? `par ${key}` : `${key}`} = ${condNew[key].join()}`,
                  showValue: isNew ? 'isNew' : '',
                  key: key,
                  value: condNew[key].join()
                })
              }
            }
          })
          condition.forEach(c => {
            c = c.sort((a, b) => b.name > a.name ? -1 : 1)
          })
          diff.push(condition)
        }
      }
    }
    state.loading = false
    commit('SETDATA', payload)
  },
  async getActivity ({ state, rootState, dispatch }, id) {
    if (!id) return
    state.loading = true
    state.error = false
    const getActivity = await fetch(`${rootState.api.host}${rootState.api.endpoint.activity}?${id}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootState.user.accesToken
      }
    })
    if (getActivity.ok) {
      const response = await getActivity.json()
      if (response) {
        dispatch('setData', response)
      }
    } else {
      state.error = true
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced
}
